import { FilterMatchMode } from 'primereact/api';

export const tableFilters = {
  stowage: { value: null, matchMode: FilterMatchMode.CONTAINS },
  booking: { value: null, matchMode: FilterMatchMode.CONTAINS },
  contenedor: { value: null, matchMode: FilterMatchMode.CONTAINS },
  armador: { value: null, matchMode: FilterMatchMode.CONTAINS },
  iso: { value: null, matchMode: FilterMatchMode.CONTAINS },
  tipo: { value: null, matchMode: FilterMatchMode.CONTAINS },
  tamano: { value: null, matchMode: FilterMatchMode.CONTAINS },
  destino1: { value: null, matchMode: FilterMatchMode.CONTAINS },
  nombreDestino: { value: null, matchMode: FilterMatchMode.CONTAINS },
  statusOut: { value: null, matchMode: FilterMatchMode.CONTAINS },
  toneladas: { value: null, matchMode: FilterMatchMode.CONTAINS },
  imos: { value: null, matchMode: FilterMatchMode.CONTAINS },
  uns: { value: null, matchMode: FilterMatchMode.CONTAINS },
  temperatura: { value: null, matchMode: FilterMatchMode.CONTAINS },
  ventilacion: { value: null, matchMode: FilterMatchMode.CONTAINS },
  precinto1: { value: null, matchMode: FilterMatchMode.CONTAINS },
  precinto2: { value: null, matchMode: FilterMatchMode.CONTAINS },
  precinto3: { value: null, matchMode: FilterMatchMode.CONTAINS },
  precinto4: { value: null, matchMode: FilterMatchMode.CONTAINS },
  mercaderia: { value: null, matchMode: FilterMatchMode.CONTAINS },
  destinoFinal: { value: null, matchMode: FilterMatchMode.CONTAINS },
};
